import React, { useState } from 'react';
import { Container, Box } from '@mui/material';
import StyledBox from 'views/membership-module/TermsAndConditionsView/components/TabsAndConditionsSection/TabsAndConditionsSection.styles';
import { useTranslation } from 'next-i18next';
import Typography500 from 'views/common/components/UI/Typography500';
import { CustomAccordion, TabsBar } from 'views/common/components';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { RichTextRenderer } from 'views/rebranded-module/common/components';

const TabsAndConditionsSection = () => {
  const { t } = useTranslation('fe_er_terms_and_conditions_page');
  const appNavigator = useAppNavigator();
  const content = useContent();
  const tablinks = [
    {
      value: 1,
      label: t('fe_er_terms_and_conditions_page:rentals'),
      href: PATHS.rentals.rentalTerms(),
      component: NavigatorLink,
    },
    {
      value: 2,
      label: t('fe_er_terms_and_conditions_page:self_drive_tours'),
      href: PATHS.tour.selfDriveTourTerms(),
      component: NavigatorLink,
    },
    {
      value: 3,
      label: t('fe_er_terms_and_conditions_page:guided_tours'),
      href: PATHS.tour.guidedTourTerms(),
      component: NavigatorLink,
    },
    {
      value: 4,
      label: t('fe_er_terms_and_conditions_page:membership'),
      href: PATHS.membership.termsAndConditions(),
      component: NavigatorLink,
    },
    {
      value: 5,
      label: t('fe_er_terms_and_conditions_page:gift_cards'),
      component: NavigatorLink,
      href: PATHS.rentals.terms(),
    },
    {
      label: t('fe_er_terms_and_conditions_page:rewards'),
      value: 6,
      href: PATHS.rewardsTermsAndConditions(),
      component: NavigatorLink,
    },
  ];
  const [selectedTab, setSelectedTab] = useState(4);
  const handleTabClick = (e, value) => {
    setSelectedTab(value);
  };

  const terms = {
    termsTitle: content.MembershipTermsAndConditionsPage.pageTitle,
    description: t('fe_er_terms_and_conditions_page:membership_tc_desc'),
    termsList: [
      {
        id: 1,
        title: t(
          'fe_er_terms_and_conditions_page:requirements_and_eligibility',
        ),
        desc: t(
          'fe_er_terms_and_conditions_page:requirements_and_eligibility_details',
        ),
      },
      {
        id: 2,
        title: t('fe_er_terms_and_conditions_page:terms_of_membership'),
        desc: t('fe_er_terms_and_conditions_page:terms_of_membership_details', {
          user_membership: appNavigator.getUrl(
            undefined,
            PATHS.user.membership().url,
            true,
          ),
          information: appNavigator.getUrl(
            undefined,
            PATHS.information().url,
            true,
          ),
        }),
      },
      {
        id: 3,
        title: t(
          'fe_er_terms_and_conditions_page:registration_and_subscription',
        ),
        desc: t(
          'fe_er_terms_and_conditions_page:registration_and_subscription_details',
          {
            motorcycle_club: appNavigator.getUrl(
              undefined,
              PATHS.motorcycleClub.index().url,
              true,
            ),
          },
        ),
      },
      {
        id: 4,
        title: t('fe_er_terms_and_conditions_page:limitations'),
        desc: t('fe_er_terms_and_conditions_page:limitations_details'),
      },
      {
        id: 5,
        title: t('fe_er_terms_and_conditions_page:membership_benefits'),
        desc: t('fe_er_terms_and_conditions_page:membership_benefits_details', {
          motorcycle_club: appNavigator.getUrl(
            undefined,
            PATHS.motorcycleClub.index().url,
            true,
          ),
          faqs_membership: appNavigator.getUrl(
            undefined,
            PATHS.faqs.withSlug('membership').url,
            true,
          ),
        }),
      },
      {
        id: 6,
        title: t(
          'fe_er_terms_and_conditions_page:membership_benefits_explained',
        ),
        desc: t(
          'fe_er_terms_and_conditions_page:membership_benefits_explained_details',
          {
            motorcycle_club: appNavigator.getUrl(
              undefined,
              PATHS.motorcycleClub.index().url,
              true,
            ),
            faqs_membership: appNavigator.getUrl(
              undefined,
              PATHS.faqs.withSlug('membership').url,
              true,
            ),
            motorcycle_club_anchor: `${appNavigator.getUrl(
              undefined,
              PATHS.motorcycleClub.index().url,
              true,
            )}#available-motorcycles`,
            home: appNavigator.getUrl(undefined, PATHS.home().url, true),
          },
        ),
      },
      {
        id: 7,
        title: t('fe_er_terms_and_conditions_page:rental_credit_usage'),
        desc: t('fe_er_terms_and_conditions_page:rental_credit_usage_details', {
          motorcycle_club: appNavigator.getUrl(
            undefined,
            PATHS.motorcycleClub.index().url,
            true,
          ),
          motorcycle_club_anchor: `${appNavigator.getUrl(
            undefined,
            PATHS.motorcycleClub.index().url,
            true,
          )}#available-motorcycles`,
        }),
      },
      {
        id: 8,
        title: t(
          'fe_er_terms_and_conditions_page:redeeming_membership_credits',
        ),
        desc: t(
          'fe_er_terms_and_conditions_page:redeeming_membership_credits_details',
          {
            home: appNavigator.getUrl(undefined, PATHS.home().url, true),
          },
        ),
      },
      {
        id: 9,
        title: t('fe_er_terms_and_conditions_page:renewal_and_grace_period'),
        desc: t(
          'fe_er_terms_and_conditions_page:renewal_and_grace_period_details',
        ),
      },
      {
        id: 10,
        title: t('fe_er_terms_and_conditions_page:fees_and_billing'),
        desc: t('fe_er_terms_and_conditions_page:fees_and_billing_details', {
          motorcycle_club: appNavigator.getUrl(
            undefined,
            PATHS.motorcycleClub.index().url,
            true,
          ),
        }),
      },
      {
        id: 11,
        title: t('fe_er_terms_and_conditions_page:failure_to_Collect'),
        desc: t('fe_er_terms_and_conditions_page:failure_to_Collect_details'),
      },
      {
        id: 12,
        title: t('fe_er_terms_and_conditions_page:membership_termination'),
        desc: t(
          'fe_er_terms_and_conditions_page:membership_termination_details',
          {
            user_membership: appNavigator.getUrl(
              undefined,
              PATHS.user.membership().url,
              true,
            ),
          },
        ),
      },
      {
        id: 13,
        title: t('fe_er_terms_and_conditions_page:upgrade_membership_plan'),
        desc: t(
          'fe_er_terms_and_conditions_page:upgrade_membership_plan_details',
        ),
      },
      {
        id: 14,
        title: t('fe_er_terms_and_conditions_page:change_payment_option'),
        desc: t(
          'fe_er_terms_and_conditions_page:change_payment_option_details',
          {
            user_membership: appNavigator.getUrl(
              undefined,
              PATHS.user.membership().url,
              true,
            ),
            rental_tc: appNavigator.getUrl(
              undefined,
              PATHS.rentals.rentalTerms().url,
              true,
            ),
          },
        ),
      },
      {
        id: 15,
        title: t('fe_er_terms_and_conditions_page:termination_by_us'),
        desc: t('fe_er_terms_and_conditions_page:termination_by_us_details'),
      },
      {
        id: 16,
        title: t('fe_er_terms_and_conditions_page:booking_changes'),
        desc: t('fe_er_terms_and_conditions_page:booking_changes_details'),
      },
      {
        id: 17,
        title: t('fe_er_terms_and_conditions_page:customer_service'),
        desc: t('fe_er_terms_and_conditions_page:customer_service_details', {
          contact_us: appNavigator.getUrl(
            undefined,
            PATHS.contactUs().url,
            true,
          ),
        }),
      },
    ],
  };

  return (
    <StyledBox>
      <Box className="TACSTabsSection">
        <Container maxWidth="xl">
          <TabsBar
            tabs={tablinks}
            selectedTab={selectedTab}
            handleTabClick={handleTabClick}
          />
        </Container>
      </Box>
      <Container maxWidth="xl">
        <Typography500 component="h1" variant="h3" className="TACSTitle">
          {terms.termsTitle}
        </Typography500>
        <Box my={2}>
          <RichTextRenderer
            content={content.MembershipTermsAndConditionsPage.pageDescription}
          />
        </Box>
        {content.MembershipTermsAndConditionsPage.accordionItems.map((item) => (
          <CustomAccordion
            key={item.accordionTitle}
            accordionDesc={item.accordionDesc}
            accordionTitle={item.accordionTitle}
            accordionHref={`#${item.accordionId}`}
          />
        ))}
      </Container>
    </StyledBox>
  );
};

export { TabsAndConditionsSection };
